"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLoader = void 0;
const store_1 = __importDefault(require("../store"));
const covers = require('./../../static/data/covers.json');
class ImageLoader {
    /**
    * Preload the images that belong to a specific question. This can be done when
    * the user reaches the question before so that, by the time that question is
    * answered, the pre-loaded question can be instantly shown.
    *
    * @param {number} questionNumber
    * @returns void
    */
    static preload(questionNumber) {
        if (!store_1.default || !store_1.default.getters || typeof store_1.default.getters.question !== 'function') {
            console.warn('ImagePreloader.preload: store functionality not available.');
            return;
        }
        const questionInfo = store_1.default.getters.question(questionNumber);
        const imagesToPreload = questionInfo.options.map(_ => {
            return `//monet-prtl-co.imgix.net/Shared/CountryTest/${questionInfo.type}/${_.id}.jpg`;
        });
        imagesToPreload.forEach(src => {
            // Simply creating a new image with the right source is enough for the image to be pre-loaded.
            const image = new Image();
            image.src = src;
        });
    }
    /**
    * Get the url of the cover image that corresponds to the main country that is
    * promoted on the results page.
    *
    * @returns {string}
    */
    static getCountryCoverImageUrl(iso) {
        return `//storage-prtl-co.imgix.net/${covers.images[iso]}`;
    }
}
exports.ImageLoader = ImageLoader;
